import script from "./RenderSettings.vue?vue&type=script&lang=ts"
export * from "./RenderSettings.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__